import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { NarudzbeService } from './narudzbe.service';
import { moduli } from '../../config';
import { PdfZaNarudzbeService } from 'src/app/pdf-ovi/pdfZaNarudzbe.service';
import { custom } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-narudzbe',
  templateUrl: './narudzbe.component.html',
  styleUrls: ['./narudzbe.component.scss']
})
export class NarudzbeComponent implements OnInit {

  idkorisnik: any;
  access_token: any;
  idfirma: any;

  narudzbe: any[] = [];
  prijevoznici = [];
  poslovniceTomo: any = [];
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');
  poruka: string;
  disableGumb: boolean = false;

  naslov: string;
  povezani_dokumenti: any = [];
  povezaniDokumentiPopup = false;
  window: any;

  aktivnoBtn = true;
  sveNarudzbe = 1;
  isRazlikaVisible = false;

  arrayZautovar: any = [
    {vrijednost: 1, ut_naziv: 'DA'},
    {vrijednost: 0, ut_naziv: ''}
  ];

  arrayObradena: any = [
    {vrijednost: 1, ob_naziv: 'DA'},
    {vrijednost: 0, ob_naziv: 'NE'}
  ];

  arrayVrsta = [
    { vrijednost: 1, naziv: 'Smrznuto' },
    { vrijednost: 0, naziv: 'Redovna' },
  ];
  vrsta = 1;

  arrayFirma = [
    { vrijednost: 2, naziv: 'Pekar d.o.o.' },
    { vrijednost: 3, naziv: 'Pekar Tomo d.o.o' },
  ];
  firma = 3;
  prikaziOtpremnicu: boolean = false;
  dozvoliUredivanje: boolean = true;

  doId: any;
  stavke: any = [];
  isLoading: boolean = true;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private _narudzbeService: NarudzbeService, private pdfZaNarudzbeService: PdfZaNarudzbeService) {

    this.idkorisnik = localStorage.getItem('idsecuser');
    this.access_token = sessionStorage.getItem('token');
    this.idfirma = localStorage.getItem('firma');

    this.dohvatiPoslovniceTomo();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().narudzbe;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    },
    {
      locateInMenu:'auto',
      location: 'before',
      widget: 'dxButton',
      template: "sve"
    },
    {
      locateInMenu:'auto',
      location: 'before',
      widget: 'dxButton',
      template: "razlika"
    },
    {
      locateInMenu: 'auto',
      location: 'before',
      widget: 'dxButton',
      template: 'pdfrazlika'
    });
  }

  onRowClick(e) {
    if (
      e.rowType === 'data' &&
      e.handled !== true &&
      e.event.target.className !== 'dx-button-text'
    ) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onCellPrepared(options) {
    if (options.rowType === 'data' && options.data.do_obradjena === 1) {
      //console.log(options);
      /*
      if (options.columnIndex === 9) {
        options.cellElement.classList.add('not-visible');
      }
      */
    }
  }

  onRowPrepared(e: any) {
    if (e.rowType === 'data') {
      if (e.data.razlika_broj < 0) {
        e.rowElement.style.backgroundColor = '#f5c6cb';
      }
      
      if (e.data.razlika_broj == 0) {
        e.rowElement.style.backgroundColor = '#C0EBA6';
      }
    }
  }

  pdfNarudzba(data) {
    this.pdfZaNarudzbeService.pdfNarudzba(data);
  }

  kreirajOtpremnicu(e){
    console.log(e);
    let myDialog = custom({
      title: "Kreiranje otpremnice",
      messageHtml: "Jeste li sigurni da želite kreirati otpremnicu?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        this._narudzbeService.otpremnica_iz_narudzbe({
          'idkorisnik': this.idkorisnik,
          'idfirma': this.idfirma,
          'access_token': this.access_token,
          'do_id': e.data.do_id
        }).subscribe(res=>{
          if(res.success == true){
            this.dohvatiNarudzbe();
            notify('Uspješno ste kreirali otpremnicu.', 'success');
          } else {
            notify(res.message, 'error');
          }
        });
      }else{  }
    });
  }

  dohvatiPoslovniceTomo(){
    this.poslovniceTomo = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
    };
    this._narudzbeService.dohvatiPoslovniceTomo(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.poslovniceTomo = res.data;
      } else {
        
      }
    });
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
  }

  promjenaVrste(e) {
    //console.log(e);
    this.vrsta = e.value;
  }

  promjenaFirme(e) {
    //console.log(e);
    this.firma = e.value;
  }

  pretrazi(){
    console.log('Pozivam dohvatiNarudzbe s firmom:', this.firma);
    this.dohvatiNarudzbe();
  }

  dohvatiNarudzbe(){
    this.poruka = 'Učitavanje...';
    this.disableGumb = true;
    this.narudzbe = [];
    console.log('firma: ', this.firma);
    if (this.firma === 2){
      console.log('firma 2');
      this.prikaziOtpremnicu = true;
      this.dozvoliUredivanje = false;
    } else if (this.firma === 3) {
      console.log('firma 3');
      this.prikaziOtpremnicu = false;
      this.dozvoliUredivanje = true;
    }
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.firma,
      datumod: this.datumOdFormatiran,
      datumdo: this.datumDoFormatiran,
      sve: this.sveNarudzbe,
      vrsta: this.vrsta
    };
    //console.log(podaciZaSlanje);
    this._narudzbeService.dokumentPopis(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.disableGumb = false;
      if (res.success == true) {
        this.narudzbe = res.data;
      }

      if (this.narudzbe.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  urediNarudzbu(e){
    //console.log(e.data);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      iddokument: e.data.do_id,
      do_zautovar: e.data.do_zautovar,
      poslovnicapartnera_pp_idTomo: e.data.poslovnicapartnera_pp_idTomo
    }
    //console.log(podaciZaSlanje);
    this._narudzbeService.dokumentUredi(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.dohvatiNarudzbe();
      if (res.success === true) {
        notify('Uspješno spremljeni podaci.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  onSelectionChanged(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);

    this.isLoading = true;

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      this.doId = e.selectedRowsData[0].do_id;
      
      this.razlikaNarucenoIsporuceno();
    }
  }

  razlikaNarucenoIsporuceno(){
    this.stavke = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      dokument_do_id_narudzba: this.doId
    }
    //console.log(podaciZaSlanje);
    this._narudzbeService.razlikaNarucenoIsporuceno(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.isLoading = false;
      if (res.success === true) {
        this.stavke = res.data;
      }else{
        
      }
    });
  }

  povezaniDokumenti(data) {
    this.naslov = 'Popis povezanih dokumenata';
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      do_id: data.data.do_id,
      dv_id: 9999,
      narudzba: 1
    }

    this.povezani_dokumenti = [];
    this._narudzbeService.povezani_dokumenti_popis(podaciZaSlanje).subscribe(res=>{
      this.povezaniDokumentiPopup = true;
      if (res.success == true) {
        this.povezani_dokumenti = res.data;
      } else {
      }
    });
  }

  uredu(){
    this.povezaniDokumentiPopup = false;
  }

  sve(){
    this.sveNarudzbe = 1;
    this.dohvatiNarudzbe();
    this.aktivnoBtn = true;
    this.isRazlikaVisible = false;
  }

  razlika(){
    this.sveNarudzbe = 0;
    this.dohvatiNarudzbe();
    this.aktivnoBtn = false;
    this.isRazlikaVisible = true;
  }

  generirajSveNarudzbePdf() {
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      datumod: this.datumOdFormatiran,
      datumdo: this.datumDoFormatiran,
      sve: this.sveNarudzbe,
      vrsta: this.vrsta
    };
  
    this._narudzbeService.dokumentPopis(podaciZaSlanje).subscribe(res => {
      if (res.success) {
        const narudzbeZaglavlja = res.data;
        
        if (narudzbeZaglavlja.length === 0) {
          notify('Nema narudžbi za generisanje PDF-a.', 'error', 3000);
          return;
        }
  
        // Dobijamo stavke za svaku narudžbu
        this.dobaviSveStavke(narudzbeZaglavlja).then(sveNarudzbeSaStavkama => {
          this.pdfZaNarudzbeService.generirajPdfZaSveNarudzbe(sveNarudzbeSaStavkama);
        });
        
      } else {
        notify('Nema podataka za PDF.', 'error', 3000);
      }
    });
  }

  dobaviSveStavke(narudzbeZaglavlja): Promise<any[]> {
    let narudzbeSaStavkama = [];
  
    return new Promise((resolve) => {
      let brojac = 0;
  
      narudzbeZaglavlja.forEach(narudzba => {
        let podaciZaSlanje = {
          idkorisnik: this.idkorisnik,
          idfirma: this.idfirma,
          dokument_do_id_narudzba: narudzba.do_id
        };
  
        this._narudzbeService.razlikaNarucenoIsporuceno(podaciZaSlanje).subscribe(res => {
          if (res.success) {
            narudzba.stavke = res.data;
          } else {
            narudzba.stavke = [];
          }
  
          narudzbeSaStavkama.push(narudzba);
          brojac++;
  
          // Kada su sve stavke dobijene, vraćamo rezultat
          if (brojac === narudzbeZaglavlja.length) {
            resolve(narudzbeSaStavkama);
          }
        });
      });
    });
  }
  
  ngOnInit(): void {
  }

}
